<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon
        v-if="status === recognitionStatus.PendingRecognizing || status === recognitionStatus.InRecognitionQueue"
        class="loading-icon"
        v-on="on"
        color="grey darken-1"
      >
        mdi-loading
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.OcrProcess"
        v-on="on"
        color="deep-purple lighten-2"
      >
        mdi-text-box-search
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.BeingRecognised"
        v-on="on"
        color="blue accent-3"
      >
        mdi-brain
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.Recognized"
        v-on="on"
        color="green lighten-2"
      >
        mdi-progress-check
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.Validated"
        v-on="on"
        color="light-green darken-3"
      >
        mdi-file-check-outline
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.PendingReview"
        v-on="on"
        color="amber darken-1"
      >
        mdi-file-document
      </v-icon>
      <v-icon
        v-else-if="status === recognitionStatus.Failed"
        v-on="on"
        color="red accent-4"
      >
        mdi-text-box-remove-outline
      </v-icon>
    </template>
    <span>{{ getTextForStatus(status) }}</span>
  </v-tooltip>
</template>

<script>
import RecognitionStatus from "@/ecm/variables/RecognitionStatus.js";

export default {
  props: {
    status: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      recognitionStatus: RecognitionStatus,
    };
  },
  methods: {
    getTextForStatus(status) {
      switch (status) {
        case 1:
          return this.$t("PendingRecognizing");
        case 3:
          return this.$t("InRecognitionQueue");
        case 2:
          return this.$t("InOcrProcess");
        case 4:
          return this.$t("BeingRecognised");
        case 5:
          return this.$t("Recognized");
        case 7:
          return this.$t("PendingReview");
        case 8:
          return this.$t("Validated");
        case 9:
          return this.$t("FailedValidation");
        default:
          return null;
      }
    }
  }
}
</script>
